import { SVGIconComponent } from '../types';

export const errorFilled: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 17 18" {...props}>
    <title>{title}</title>
    <path d="M8.5.667A8.336 8.336 0 0 0 .167 9c0 4.6 3.733 8.333 8.333 8.333S16.833 13.6 16.833 9 13.1.667 8.5.667Zm.833 12.5H7.667V11.5h1.666v1.667Zm0-3.334H7.667v-5h1.666v5Z" />
  </svg>
);
